import { render } from "./branch-ord-node.vue?vue&type=template&id=e4d419d0"
import script from "./branch-ord-node.vue?vue&type=script&lang=js"
export * from "./branch-ord-node.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__